var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{attrs:{"id":"my-steps-chart","chart-data":_vm.chartData,"goalLine":_vm.stepGoal,"showLegend":""},on:{"add-background-color":function($event){_vm.backgroundColor = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }